export const submitLeadMeritto = async (payload) => {
  const response = await fetch(
    "https://partner.medhaviskillsuniversity.edu.in/partnar/push-campus-raw-data/",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  const data = await response.json();

  console.log("Status:", response.status);
  console.log("Response:", data);

  if (!response.ok) {
    throw new Error(data.message || JSON.stringify(data));
  }

  return data;
};